import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <div className="paraspace"><p>Building trust is often a challenge
                                                whether you have a personal relationship with people or not.
                                                This tool is about<span className="brown brownbold"> how to build and maintain trust</span> and
                                                will help you to recognise what trust comprises and how to
                                                increase levels of trust.</p>
                                            </div>

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>WHY BUILD TRUST?</div>
                                            <p>The level to which we trust those around us is critical to the
                                                success or otherwise of our collaboration and relationships with
                                                them. Employees who lack trust in one another will spend time –
                                                which would otherwise be used more constructively – monitoring
                                                one another, duplicating each other’s work and generally
                                                communicating less effectively. In extreme cases, people will
                                                deliberately withhold information or refuse to cooperate
                                                altogether.</p>
                                            <p>
                                                To prevent these kinds of problems, it’s important to build
                                                trust at the start of working relationships – but how do you do
                                                that when you’ve never worked with someone before or know
                                                nothing about them?</p>
                                            <p>This can be tough because, for most of us, the concept of trust
                                                is significant – involving the kind of personal investment we
                                                would only make after much trying and testing of someone or
                                                something. But, it’s easier than that...</p>
                                            <p>First, we’ll explain that there are different kinds of trust –
                                                three, in fact: ‘cognitive’, ‘transactional’ and ‘affective’.
                                                The first two can be achieved quickly, the third takes
                                                longer.</p>

                                            <div className="border_subtitle">Types of trust<a
                                                className="superscripttext"
                                                href="further_info.php?course=300"><sup>2</sup></a></div>
                                            <p><span className="subtiltereg">Cognitive trust</span></p>
                                            <p>This is the first stage or level of trust reached in working
                                                relationships. It’s easy to achieve quickly amongst people who
                                                have no prior knowledge of each other, such as colleagues or
                                                clients.</p>
                                            <p>Cognitive trust is about convincing others you have what’s
                                                required to complete a task with them, including things like
                                                knowledge, ability, professionalism, reliability and
                                                integrity.</p>
                                            <div className="paraspace"><p>It is, therefore, best described as a
                                                ‘task based’ trust because it’s achieved when you convince
                                                others of facts about yourself which demonstrate your capability
                                                and competence. It can be achieved through communication, even
                                                when introducing yourself, by:</p></div>
                                            <ul className="greenbullet-list people-list-pad">

                                                <li>Describing similar, previous projects you have worked on
                                                    successfully
                                                </li>
                                                <li>Referring to your relevant knowledge and experience</li>
                                                <li>Specifying your relevant skills and how you have used them
                                                    before.
                                                </li>

                                            </ul>
                                            <p>So, this is different to the kind of trust built with a
                                                long-standing and much loved friend, who, nevertheless, you
                                                might not trust to cut your hair or check your car’s brakes! In
                                                other words, to build cognitive trust you need to establish
                                                relevant facts, regardless of whatever else you know or feel
                                                about someone.</p>
                                            <div className="paraspace"><p>Cognitive trust is reinforced, on an
                                                ongoing basis by :</p></div>

                                            <ul className="greenbullet-list people-list-pad">
                                                <li>Demonstrating your knowledge in discussion</li>
                                                <li>Using your relevant skills</li>
                                                <li>Relating your own past experiences to teach others and help
                                                    them avoid mistakes
                                                </li>
                                                <li>Demonstrating your skills, to prove that they are as you
                                                    have described them.
                                                </li>
                                            </ul>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }